import {gql} from "@apollo/client";

export const getConversationWithAmbassador = gql`
    query GetConversationWithAmbassador($ambassadorId: String!) {
        getConversationWithAmbassador(ambassadorId: $ambassadorId) {
            id
        }
    }
`;
